module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@2x-a581cb98b92bd2ff76311e7621a592da.png";